/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { EnvironmentModel } from 'apps/gb-dashboard/src/environments/environment.model'

@Component({
  selector: 'gb-url-name-form-field',
  templateUrl: './gb-url-name-form-field.component.html',
  styleUrls: ['./gb-url-name-form-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class GbUrlNameFormFieldComponent {
  @Input({ required: true }) control!: any
  @Input({ required: true }) labelTranslateKey!: string
  @Input() disabled: boolean | null = false
  @Input() placeholderTranslateKey = 'FORMS.URL_NAME_PLACEHOLDER'

  constructor(@Inject(APP_CONFIG) protected appConfig: EnvironmentModel) {}
}
